import { useMemo } from "react";
import i18n from "~/i18n";
import { descSortCompare } from "~/utils/utils";

const notSetNames = {
  "category-not-set": i18n.t("Without a Category"),
  "leader-not-set": i18n.t("Without a Leader"),
  "label-not-set": i18n.t("Without a Label"),
  "user-not-set": i18n.t("Unassigned"),
  "job-type-not-set": i18n.t("Without an Estimate"),
  "not-set": i18n.t("Not Set"),
};

export const useWidgetData = (data = {}) => {
  const widgetData = useMemo(() => {
    return Object.entries(data)
      .map(([id, obj]) => ({ id, ...obj }))
      .sort((a, b) => descSortCompare(a.count, b.count))
      .reduce(
        (acc, current) => {
          const name = notSetNames[`${current.id}`] ?? current.name;
          acc.list.push({ ...current, name });
          acc.total += current.count;
          return acc;
        },
        { total: 0, list: [] }
      );
  }, [data]);

  return widgetData;
};

export const useTrackingWidgetData = (data = {}) => {
  const widgetData = useMemo(() => {
    return Object.entries(data)
      .map(([id, obj]) => ({ id, ...obj }))
      .sort((a, b) => descSortCompare(a.count, b.count))
      .reduce(
        (acc, current) => {
          const name = current.label;
          const count = current.total_time;
          acc.list.push({ count, name });
          acc.total += current.total_time;
          return acc;
        },
        { total: 0, list: [] }
      );
  }, [data]);

  return widgetData;
};
